// extracted by mini-css-extract-plugin
module.exports = {"customButton":"Button_customButton__25io2","enableButton":"Button_enableButton__W6M_c","disableButton":"Button_disableButton__RlUlv"};